export const GET_QUERY = "GET-QUERY";
export const GET_QUERY_FILTERS = "GET-QUERY-FILTERS";
export const GET_LAST_UPDATED_TIME = "GET-LAST-UPDATED-TIME";
export const GET_QUERY_BY_ID = "GET-QUERY-BY-ID";
export const GET_QUERY_GROUP_BY_ID = "GET-QUERY-GROUP-BY-ID";
export const GET_ALL_QUERY_GROUPS = "GET-ALL-QUERY-GROUPS";
export const GET_JOBS = "GET-JOBS";
export const GET_JOB_EXECUTIONS = "GET-JOB-EXECUTIONS";
export const GET_JOB_DEFINTIONS = "GET-JOB-QUERIES";
export const GET_JOB_FILTERS = "GET-JOB-FILTERS";
export const GET_QUERY_JOB_DATA = "GET-QUERY-JOB-DATA";
export const GET_DASHBOARDS = "GET-DASHBOARDS";
export const GET_BI_DASHBOARDS_SUMMARY = "GET-DASHBOARDS-SUMMARY";
export const GET_BI_DASHBOARDS_FILTERS = "GET-DASHBOARDS-FILTERS";
export const GET_BI_DASHBOARD_BY_ID = "GET-DASHBOARD-BY-ID";
export const GET_BI_USER_REPORTS = "GET-BI-USER-REPORTS";
export const GET_BI_USER_SUMMARY = "GET-BI-USER-SUMMARY";
export const GET_BI_USER_REPORTS_FILTERS = "GET-BI-USER-REPORTS-FILTERS";
export const GET_DATAMATES_CUSTOM_INTEGRATIONS = "GET_DATAMATES_CUSTOM_INTEGRATIONS";

export enum QueryGroupTabs {
  Opportunities = "Opportunities",
  Queries = "Queries",
}

export const QUERY_TEXT_API_KEY = "GET_QUERY_TEXT_BY_HASH";

export const GET_DBT_JOBS_LIST = "GET-DBT-JOBS-LIST";
export const GET_DBT_GRAPH_DATA = "GET-DBT-GRAPH-DATA";
export const GET_DBT_FILTERS = "GET-DBT-FILTERS";
export const GET_DBT_JOB_MODELS = "GET-DBT-JOB-MODELS";
export const GET_DBT_JOB_RUNS = "GET-DBT-JOB-RUNS";
export const GET_DBT_JOB_SUMMARY = "GET-DBT-JOB-SUMMARY";
export const GET_DBT_JOB_LISTING = "GET-DBT-JOB-LISTING";
export const GET_DBT_JOB_LISTING_GRAPH = "GET-DBT-JOB-LISTING-GRAPH";
export const GET_DBT_JOB_LISTING_SUMMARY = "GET-DBT-JOB-LISTING-SUMMARY";

export const PAGE_SIZE_OPTIONS: { label: string; value: string }[] = [
  { label: "50", value: "50" },
  { label: "100", value: "100" },
  { label: "200", value: "200" },
  { label: "300", value: "300" },
  { label: "All data", value: "10000" },
];

export enum ExecutionStatus {
  SUCCESS = "SUCCESS",
  FAIL = "FAIL",
}

export const EXECUTION_STATUS_OPTIONS = [
  { label: "Successful", value: ExecutionStatus.SUCCESS },
  { label: "Failed", value: ExecutionStatus.FAIL },
];
